import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { OrderKindRepositoryBase } from '@skylab-shared/business';
export { OrderKindRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(OrderKindRepositoryBase)
export class OrderKindRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
